import React from 'react';
import { useIntl } from 'react-intl';
import { WithStyles, withStyles } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';

import Typography from '../../../Typography';
import styles from './LumaBotFlowSessionLogErrorState.styles';
import messages from './LumaBotFlowSessionLogErrorState.messages';

type Props = WithStyles<typeof styles> & {
  handleRefetch?: (options?: any) => void;
};

const LumaBotFlowSessionLogErrorState: React.FC<Props> = ({ classes, handleRefetch }) => {
  const { formatMessage } = useIntl();

  return (
    <div className={classes.container}>
      <Typography variant="bW600F16" color="supportSteel">
        {formatMessage(messages.text)}
      </Typography>
      <RefreshIcon onClick={() => handleRefetch && handleRefetch()} className={classes.icon} color="primary" />
    </div>
  );
};

export default withStyles(styles)(LumaBotFlowSessionLogErrorState);
